var render = function render(){var _vm=this,_c=_vm._self._c;return _c('codemirror',{ref:"codemirror",attrs:{"value":_vm.value,"options":_vm.defaultCodeMirrorOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }